// Lightweight dev-only logger. In production builds (NODE_ENV=production)
// these calls compile down to no-ops so we don't leak diagnostic context
// or pay the cost of writing to the console on every user device.
const IS_DEV = process.env.NODE_ENV !== "production";

export const logger = {
  warn: (...args) => {
    if (IS_DEV) console.warn(...args);
  },
  error: (...args) => {
    if (IS_DEV) console.error(...args);
  },
  info: (...args) => {
    if (IS_DEV) console.info(...args);
  },
};
